<section class="main-container">

  <section class="table-content">

    <div class="class-subject-heading">

      <div>
        <h6>Grading Systems</h6>
        <small>Grade scales assigned by academic year</small>
      </div>

      <button  (click)="addGradeSystem.set(true)">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12H20M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
      </button>

    </div>

    <div class="table-wrapper">
      <table>
        <thead>
        <tr>
          <th>PUBLIC ID</th>
          <th>SYSTEM</th>
          <th>STATUS</th>
          <th>CREATED AT</th>
          <th class="options-column">ACTIONS</th>
        </tr>
        </thead>

        <tbody>
          @for (g of gradingSystems()?.payload; track $index) {
            <tr>
              <td>{{ g.public_id }}</td>
              <td>{{ g.name }}</td>
              <td class="status">
                <p [ngClass]="g.status">{{ g.status }}</p>
              </td>
              <td>{{ Helpers.formatDate(g.created_at) }}</td>

              <td class="options-column">
                <app-action-button>
                  <button (click)="selectGradeSystem(g)" class="menu-item">View details</button>
                </app-action-button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </section>

  <section class="table-content">

    <div class="class-subject-heading">

      <div>
        <h6>Class & Exam Weighting</h6>
        <small>Class and exam weighting applied by term</small>
      </div>

      <button  (click)="addGradeConfig.set(true)">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12H20M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
      </button>

    </div>

    <div class="table-wrapper">
      <table>
        <thead>
        <tr>
          <th>PUBLIC ID</th>
          <th>NAME</th>
          <th>CLASS SCORE</th>
          <th>EXAM SCORE</th>
          <th>STATUS</th>
          <th class="options-column">ACTIONS</th>
        </tr>
        </thead>

        <tbody>
          @for (g of scoreWeights()?.payload; track $index) {
            <tr>
              <td>{{ g.public_id }}</td>
              <td>{{ g.configuration_name }}</td>
              <td>{{ g.class_score }}</td>
              <td>{{ g.examination_score }}</td>
              <td class="status">
                <p [ngClass]="g.status">{{ g.status }}</p>
              </td>
              <td class="options-column">
                <app-action-button>
                  <button (click)="openEditScoreWeight(g)" class="menu-item">Edit score weight</button>
                </app-action-button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

  </section>

</section>

<section [class.show]="setGradeDetail()" class="slider">
  <div class="bg" (click)="setGradeDetail.set(false)"></div>

  <div class="slider-content">
    <div class="slider-heading">
      <div>
        <h5>{{ selectedGradeSystem.name }}</h5>
        <small>{{ selectedGradeSystem.public_id }}</small>
      </div>

      <div class="status">
        <p [ngClass]="selectedGradeSystem.status">{{ selectedGradeSystem.status }}</p>
      </div>
    </div>

    <div class="grade-breakdown">
      <h6>GRADE BREAKDOWN</h6>

      <div class="table-content">
        <div class="table-wrapper">
          <table class="grade-table">
            <colgroup>
              <col class="w-grade">
              <col class="w-range">
              <col>
            </colgroup>

            <thead>
            <tr>
              <th>GRADE</th>
              <th>RANGE</th>
              <th>REMARK</th>
            </tr>
            </thead>

            <tbody>
              @for (s of selectedGradeSystem.scales; track $index) {
                <tr>
                  <td>
                    <span class="grade-badge">{{ s.grade }}</span>
                  </td>
                  <td>
                    <span class="range">{{ s.minimum_score }} – {{ s.maximum_score }}</span>
                  </td>
                  <td class="remark">{{ s.remark }}</td>
                </tr>
              } @empty {
                <tr>
                  <td colspan="3" class="empty">No grades defined</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="slider-actions">
      <button class="secondary-button" type="button" (click)="openEditGradeSystem()">
        Edit Grade Scale
      </button>
    </div>
  </div>
</section>

@if (addGradeConfig()) {
  <section class="pop-up">
    <div class="bg" (click)="addGradeConfig.set(false)"></div>

    <form #gradeConfigForm="ngForm" (ngSubmit)="createGradeConfig(gradeConfigForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#fff" d="M13.94 3.68a1.64 1.64 0 0 0-.83-1.05 1.71 1.71 0 0 0-.49-1.25 1.665 1.665 0 0 0-1.25-.49A1.678 1.678 0 0 0 9 .26a1.678 1.678 0 0 0-2.37.63 1.665 1.665 0 0 0-1.25.49 1.71 1.71 0 0 0-.49 1.25A1.678 1.678 0 0 0 4.26 5a1.678 1.678 0 0 0 .63 2.37 1.71 1.71 0 0 0 .49 1.25 1.628 1.628 0 0 0 1.25.49 1.393 1.393 0 0 0 .37.46v8.15a.264.264 0 0 0 .07.19.214.214 0 0 0 .18.09.234.234 0 0 0 .17-.07l.01-.01L9 16.5l1.58 1.43a.234.234 0 0 0 .17.07.214.214 0 0 0 .18-.09.264.264 0 0 0 .07-.19V9.57a1.393 1.393 0 0 0 .37-.46 1.628 1.628 0 0 0 1.25-.49 1.71 1.71 0 0 0 .49-1.25A1.678 1.678 0 0 0 13.74 5a1.64 1.64 0 0 0 .2-1.32zM9 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"></path> </g></svg>          </div>
        <div>
          <h6>Add a Score Weight</h6>
          <small>Set a new configuration</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="configName">Configuration Name <span class="required-check">*</span></label>
          <input type="text" name="configName" id="configName" [(ngModel)]="configName" placeholder="e.g. 30-70 Split">
        </div>

        <div>
          <label for="classScore">Class Score <span class="required-check">*</span></label>
          <input type="number" name="classScore" id="classScore" [(ngModel)]="classScore" placeholder="e.g. 30">
        </div>

        <div>
          <label for="examScore">Examination Score <span class="required-check">*</span></label>
          <input type="number" name="examScore" id="examScore" [(ngModel)]="examScore" placeholder="e.g. 70">
        </div>

        <button class="secondary-button add-term-btn" [disabled]="gradeConfigForm.invalid || ((classScore + examScore) !== 100)">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Add Score Weight
          }
        </button>
      </div>

    </form>
  </section>
}

@if (editScoreWeight()) {
  <section class="pop-up">
    <div class="bg" (click)="editScoreWeight.set(false)"></div>

    <form #editScoreWeightForm="ngForm" (ngSubmit)="updateScoreWeight(editScoreWeightForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#fff" d="M13.94 3.68a1.64 1.64 0 0 0-.83-1.05 1.71 1.71 0 0 0-.49-1.25 1.665 1.665 0 0 0-1.25-.49A1.678 1.678 0 0 0 9 .26a1.678 1.678 0 0 0-2.37.63 1.665 1.665 0 0 0-1.25.49 1.71 1.71 0 0 0-.49 1.25A1.678 1.678 0 0 0 4.26 5a1.678 1.678 0 0 0 .63 2.37 1.71 1.71 0 0 0 .49 1.25 1.628 1.628 0 0 0 1.25.49 1.393 1.393 0 0 0 .37.46v8.15a.264.264 0 0 0 .07.19.214.214 0 0 0 .18.09.234.234 0 0 0 .17-.07l.01-.01L9 16.5l1.58 1.43a.234.234 0 0 0 .17.07.214.214 0 0 0 .18-.09.264.264 0 0 0 .07-.19V9.57a1.393 1.393 0 0 0 .37-.46 1.628 1.628 0 0 0 1.25-.49 1.71 1.71 0 0 0 .49-1.25A1.678 1.678 0 0 0 13.74 5a1.64 1.64 0 0 0 .2-1.32zM9 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"></path> </g></svg>          </div>
        <div>
          <h6>Edit Score Weight</h6>
          <small>Update class and exam weighting</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="editConfigName">Configuration Name <span class="required-check">*</span></label>
          <input type="text" name="editConfigName" id="editConfigName" [(ngModel)]="editScoreWeightName" placeholder="e.g. 30-70 Split" required>
        </div>

        <div>
          <label for="editConfigDescription">Description</label>
          <input type="text" name="editConfigDescription" id="editConfigDescription" [(ngModel)]="editScoreWeightDescription" placeholder="e.g. Junior secondary weighting">
        </div>

        <div>
          <label for="editClassScore">Class Score <span class="required-check">*</span></label>
          <input type="number" name="editClassScore" id="editClassScore" [(ngModel)]="editScoreWeightClassScore" placeholder="e.g. 30" required>
        </div>

        <div>
          <label for="editExamScore">Examination Score <span class="required-check">*</span></label>
          <input type="number" name="editExamScore" id="editExamScore" [(ngModel)]="editScoreWeightExamScore" placeholder="e.g. 70" required>
        </div>

        <div>
          <label for="editConfigStatus">Status <span class="required-check">*</span></label>
          <select name="editConfigStatus" id="editConfigStatus" [(ngModel)]="editScoreWeightStatus" required>
            @for (s of gradeSystemStatuses; track s) {
              @if (selectedScoreWeight?.status !== 'ARCHIVED' || s === 'ARCHIVED') {
                <option [value]="s">{{ s }}</option>
              }
            }
          </select>
        </div>

        <button class="secondary-button add-term-btn" [disabled]="editScoreWeightForm.invalid || ((editScoreWeightClassScore + editScoreWeightExamScore) !== 100) || isEditing()">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Update Score Weight
          }
        </button>
      </div>

    </form>
  </section>
}

@if (addGradeSystem()) {
  <section class="pop-up">
    <div class="bg" (click)="addGradeSystem.set(false)"></div>

    <form #gradeSystemForm="ngForm" (ngSubmit)="createGradeSystem(gradeSystemForm)" class="grade-system-form">
      <div class="form-heading">
        <div class="image-box">
          <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#fff" d="M13.94 3.68a1.64 1.64 0 0 0-.83-1.05 1.71 1.71 0 0 0-.49-1.25 1.665 1.665 0 0 0-1.25-.49A1.678 1.678 0 0 0 9 .26a1.678 1.678 0 0 0-2.37.63 1.665 1.665 0 0 0-1.25.49 1.71 1.71 0 0 0-.49 1.25A1.678 1.678 0 0 0 4.26 5a1.678 1.678 0 0 0 .63 2.37 1.71 1.71 0 0 0 .49 1.25 1.628 1.628 0 0 0 1.25.49 1.393 1.393 0 0 0 .37.46v8.15a.264.264 0 0 0 .07.19.214.214 0 0 0 .18.09.234.234 0 0 0 .17-.07l.01-.01L9 16.5l1.58 1.43a.234.234 0 0 0 .17.07.214.214 0 0 0 .18-.09.264.264 0 0 0 .07-.19V9.57a1.393 1.393 0 0 0 .37-.46 1.628 1.628 0 0 0 1.25-.49 1.71 1.71 0 0 0 .49-1.25A1.678 1.678 0 0 0 13.74 5a1.64 1.64 0 0 0 .2-1.32zM9 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"></path> </g></svg>
        </div>
        <div>
          <h6>Add a Grading System</h6>
          <small>Create grade scales for this school</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="gradeSystemName">System Name <span class="required-check">*</span></label>
          <input type="text" name="gradeSystemName" id="gradeSystemName" [(ngModel)]="gradeSystemName" placeholder="e.g. Standard Grading" required>
        </div>

        <div>
          <label for="gradeSystemDescription">Description</label>
          <input type="text" name="gradeSystemDescription" id="gradeSystemDescription" [(ngModel)]="gradeSystemDescription" placeholder="e.g. General grading system">
        </div>

        <div>
          <label for="gradeSystemStatus">Status <span class="required-check">*</span></label>
          <select name="gradeSystemStatus" id="gradeSystemStatus" [(ngModel)]="gradeSystemStatus" required>
            <option value="DRAFT">Draft</option>
            <option value="ACTIVE">Active</option>
            <option value="ARCHIVED">Archived</option>
          </select>
        </div>

        <div class="grade-scales-section">
          <div class="grade-scale-header">
            <label>Grade Scales <span class="required-check">*</span></label>
            <button type="button" (click)="addScale()" class="add-scale-btn">+ Add Scale</button>
          </div>

          <div class="grade-scales-container">
            @for (scale of gradeScales; track $index) {
              <div class="grade-scale-row">
                <input type="number" step="0.01" [(ngModel)]="scale.minimum_score" [name]="'min' + $index" placeholder="Min">
                <input type="number" step="0.01" [(ngModel)]="scale.maximum_score" [name]="'max' + $index" placeholder="Max">
                <input type="text" [(ngModel)]="scale.grade" [name]="'grade' + $index" placeholder="Grade">
                <input type="text" [(ngModel)]="scale.remark" [name]="'remark' + $index" placeholder="Remark">
                <button class="close-btn" type="button" (click)="removeScale($index)" [disabled]="gradeScales.length === 1">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#dc2626"></path> </g></svg>
                </button>
              </div>
            }
          </div>
        </div>

        <button class="secondary-button add-term-btn" [disabled]="gradeSystemForm.invalid || isEditing()">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Add Grading System
          }
        </button>
      </div>

    </form>
  </section>
}

@if (editGradeSystem()) {
  <section class="pop-up">
    <div class="bg" (click)="editGradeSystem.set(false)"></div>

    <form #editGradeSystemForm="ngForm" (ngSubmit)="updateGradeSystem(editGradeSystemForm)" class="grade-system-form">
      <div class="form-heading">
        <div class="image-box">
          <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="#fff" stroke="#fff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#fff" d="M13.94 3.68a1.64 1.64 0 0 0-.83-1.05 1.71 1.71 0 0 0-.49-1.25 1.665 1.665 0 0 0-1.25-.49A1.678 1.678 0 0 0 9 .26a1.678 1.678 0 0 0-2.37.63 1.665 1.665 0 0 0-1.25.49 1.71 1.71 0 0 0-.49 1.25A1.678 1.678 0 0 0 4.26 5a1.678 1.678 0 0 0 .63 2.37 1.71 1.71 0 0 0 .49 1.25 1.628 1.628 0 0 0 1.25.49 1.393 1.393 0 0 0 .37.46v8.15a.264.264 0 0 0 .07.19.214.214 0 0 0 .18.09.234.234 0 0 0 .17-.07l.01-.01L9 16.5l1.58 1.43a.234.234 0 0 0 .17.07.214.214 0 0 0 .18-.09.264.264 0 0 0 .07-.19V9.57a1.393 1.393 0 0 0 .37-.46 1.628 1.628 0 0 0 1.25-.49 1.71 1.71 0 0 0 .49-1.25A1.678 1.678 0 0 0 13.74 5a1.64 1.64 0 0 0 .2-1.32zM9 7a2 2 0 1 1 2-2 2 2 0 0 1-2 2z"></path> </g></svg>
        </div>
        <div>
          <h6>Edit Grade Scale</h6>
          <small>Update the grading system details</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="editGradeSystemName">System Name <span class="required-check">*</span></label>
          <input type="text" name="editGradeSystemName" id="editGradeSystemName" [(ngModel)]="editGradeSystemName" placeholder="e.g. Standard Grading" required>
        </div>

        <div>
          <label for="editGradeSystemDescription">Description</label>
          <input type="text" name="editGradeSystemDescription" id="editGradeSystemDescription" [(ngModel)]="editGradeSystemDescription" placeholder="e.g. General grading system">
        </div>

        <div>
          <label for="editGradeSystemStatus">Status <span class="required-check">*</span></label>
          <select name="editGradeSystemStatus" id="editGradeSystemStatus" [(ngModel)]="editGradeSystemStatus" required>
            @for (s of gradeSystemStatuses; track s) {
              @if (!(selectedGradeSystem.status === 'ARCHIVED' && s === 'ACTIVE')) {
                <option [value]="s">{{ s }}</option>
              }
            }
          </select>
        </div>

        <div class="grade-scales-section">
          <div class="grade-scale-header">
            <label>Grade Scales <span class="required-check">*</span></label>
            <button type="button" (click)="addScale('edit')" class="add-scale-btn">+ Add Scale</button>
          </div>

          <div class="grade-scales-container">
            @for (scale of editGradeScales; track $index) {
              <div class="grade-scale-row">
                <input type="number" step="0.01" [(ngModel)]="scale.minimum_score" [name]="'editMin' + $index" placeholder="Min" required>
                <input type="number" step="0.01" [(ngModel)]="scale.maximum_score" [name]="'editMax' + $index" placeholder="Max" required>
                <input type="text" [(ngModel)]="scale.grade" [name]="'editGrade' + $index" placeholder="Grade" required>
                <input type="text" [(ngModel)]="scale.remark" [name]="'editRemark' + $index" placeholder="Remark">
                <button class="close-btn" type="button" (click)="removeScale($index, 'edit')" [disabled]="editGradeScales.length === 1">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z" fill="#dc2626"></path> </g></svg>
                </button>
              </div>
            }
          </div>
        </div>

        <button class="secondary-button add-term-btn" [disabled]="editGradeSystemForm.invalid || isEditing()">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Update Grading System
          }
        </button>
      </div>

    </form>
  </section>
}

